export const showConfirmation = (title, body, success) => {
    const $confirmation = $('#instant-confirmation');
    const $modal = $confirmation.find('.modal');
    $modal.find('.modal-title').html(title);
    $modal.find('.modal-body').html(body);
    $modal.find('.modal-footer > button.btn-default')
        .off('click')
        .click(ev => {
            ev.preventDefault();
            success();
            $modal.modal('hide');
        });
    $modal.find('.modal-footer > button.btn-action')
        .off('click')
        .click(ev => {
            ev.preventDefault();
            $modal.modal('hide');
        });
    $modal.one('hidden.bs.modal', () => {
        $confirmation.css('display', 'none');
    });
    $confirmation.css('display', 'block');
    $modal.modal('show');
};
